import React, { useState } from 'react'
import UserPosts from './UserPosts';
import { useSelector } from 'react-redux';

const PostsInfoCard = ({ userId }) => {
  const [curr, setCurr] = useState("My");
  const { user } = useSelector((state) => state.user);
  const isOwnProfile = user && user._id === userId;

  const Tab = ({ label, id }) => (
    <button
      onClick={() => setCurr(id)}
      className={`relative px-6 py-2.5 rounded-full text-xs font-black uppercase tracking-wider transition-all duration-300 whitespace-nowrap flex-shrink-0 ${
        curr === id 
          ? 'bg-slate-900 text-white shadow-lg shadow-slate-300/50 scale-105' 
          : 'bg-transparent text-slate-500 hover:bg-slate-100 hover:text-slate-700'
      }`}
    >
      {label}
    </button>
  );

  return (
    <div className="flex flex-col h-full bg-white">
      {/* Header / Tabs */}
      <div className="flex items-center gap-2 px-6 sm:px-10 py-6 border-b border-slate-100 bg-white sticky top-0 z-10 overflow-x-auto no-scrollbar">
        <Tab label={isOwnProfile ? "My Experiences" : "Experiences"} id="My" />
        {isOwnProfile && <Tab label="Bookmarked" id="Saved" />}
        <Tab label="Liked" id="Liked" />
      </div>

      {/* Content Area */}
      <div className="flex-grow bg-slate-50/50">
        <UserPosts userId={userId} curr={curr} />
      </div>
    </div>
  );
};

export default PostsInfoCard
